import { forwardRef } from "react";
import cx from "../../../utils/cx.ts";

type Props = {
  label?: string;
  children: JSX.Element[] | JSX.Element;
};

const FormSection = forwardRef<HTMLDivElement, Props>(
  ({ label, children }: Props, ref) => (
    <div className="border-b border-gray-900/10" ref={ref}>
      {label != null && (
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          {label}
        </h2>
      )}
      <div
        className={cx(
          label != null ? "mt-6" : "",
          "mb-8 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6",
        )}
      >
        {children}
      </div>
    </div>
  ),
);

FormSection.displayName = "FormSection";

export default FormSection;
